import {
  type CreditScoreColor,
  getCreditScoreStatusLabel,
  getCreditScoreStyle,
} from "@krea/lender-features/components/credit-score-pill";
import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";
import { cn } from "@krea/shared/utils";

export type IndicatorRisk = CreditScoreColor;

export const Indicator = ({
  className,
  risk,
  status,
}: {
  className?: string;
  risk?: IndicatorRisk | null;
  status?: string | null;
}) => {
  // SE UC alphabetic class (e.g. "K" = Bankruptcy): show the letter inside a
  // neutral primary-200 orb, with the class meaning on hover.
  if (status) {
    const statusLabel = getCreditScoreStatusLabel(status);

    return (
      <ResponsiveTooltip
        trigger={
          <span
            role="img"
            aria-label={statusLabel}
            className={cn(
              "inline-flex size-5 items-center justify-center rounded-full bg-primary-200 text-[10px] font-semibold text-primary-400",
              className,
            )}
          >
            {status}
          </span>
        }
      >
        {statusLabel}
      </ResponsiveTooltip>
    );
  }

  const { dot, label } = getCreditScoreStyle(risk);

  return (
    <ResponsiveTooltip
      trigger={
        <span
          role="img"
          aria-label={label}
          className={cn("inline-block size-5 rounded-full", dot, className)}
        />
      }
    >
      {label}
    </ResponsiveTooltip>
  );
};
